import styled from "styled-components";

import NewWorldScrollImg from "./img/7433.gif"


function HeroTrackIIIQuests() {
    return(<>
            <ClassListContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={NewWorldScrollImg}/>
                    <ClassListDescription>Assauto a Aeronave</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={NewWorldScrollImg}/>
                    <ClassListDescription>Sarah e Fenrir</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>
            </>
    )
}


const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    cursor: pointer;
    transition: .2s ease-in-out;

    &:hover {
        background-color: rgba(74, 108, 201, 0.2);
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default HeroTrackIIIQuests;